import { fetchDesktopWithTimeout } from '@/lib/fetchDesktopWithTimeout';
import { useMutation } from '@tanstack/react-query';

async function callDesktop({ number }: { number: string }) {
  if (!number) throw new Error('invalid-number');

  const res = await fetchDesktopWithTimeout(
    "/call",
    {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ phone: number }),
    },
    1200
  );

  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(text || `desktop-call-failed-${res.status}`);
  }
  return true as const;
}

export function useDesktopCall() {
  return useMutation({
    mutationFn: callDesktop,
    retry: 0,
  });
}
